import { getPostBySlug, getRelatedPostsByTags } from '$lib/posts';
import { error, type Load } from '@sveltejs/kit';

export const load: Load = ({ params: { slug } }) => {
	const post = getPostBySlug(slug!);

	if (!post) {
		error(404, { message: 'Post not found' });
	}

	return {
		posts: getRelatedPostsByTags(post.metadata.tags, 5),
		page: post.default
	};
};
